import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import helpers from '../utils/fieldsHelper';
import Button from '../../../../core/Button';
import DropdownButton from '../../../../core/DropdownButton';
import Typography from '@material-ui/core/Typography';
import Utils from '../../../../utils';
import fieldsLogic from '../logic/fieldsLogic';
import LookupDialog from '../binding/LookupDialog';
import useBinding from '../binding/useBinding';

var RepeatingAddButton = function RepeatingAddButton(_ref) {
  var items = _ref.items,
      disableAddButton = _ref.disableAddButton,
      addBtnContent = _ref.addBtnContent,
      dispatch = _ref.dispatch,
      fieldId = _ref.fieldId;
  var binding = useBinding(fieldId);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onLookup = function onLookup() {
    return setOpen(true);
  };

  var onClose = function onClose(e, reason) {
    if (reason && reason == 'backdropClick') return;
    setOpen(false);
  };

  var onAddItem = function onAddItem() {
    var values = items && items.map(function (i) {
      return i.value;
    });
    var nextValue = values.length == 0 ? 0 : values[values.length - 1] + 1;
    var newValues = values.concat([nextValue]);
    fieldsLogic.onRepeatingChange(fieldId, newValues, dispatch);
  };

  return React.createElement(React.Fragment, null, !binding && React.createElement(Button, {
    onClick: onAddItem,
    disabled: disableAddButton,
    variant: "outlined",
    size: "small",
    color: "default"
  }, React.createElement(Typography, {
    dangerouslySetInnerHTML: {
      __html: helpers.getHtmlMarkup(addBtnContent)
    }
  })), binding && React.createElement(DropdownButton, {
    label: "Add",
    type: "add",
    disabled: disableAddButton,
    showArrowIcon: true,
    labelPlacement: "end",
    style: {
      paddingTop: '1px',
      paddingBottom: '1px'
    },
    buttonProps: {
      size: 'small',
      variant: 'outlined'
    },
    options: [{
      label: 'Add New',
      onClick: onAddItem
    }, {
      label: 'Select Data',
      onClick: onLookup
    }]
  }), open && React.createElement(LookupDialog, {
    onClose: onClose,
    fieldId: fieldId,
    title: "Select"
  }));
};

export default React.memo(RepeatingAddButton, function (prevProps, nextProps) {
  return Utils.deepEqual(prevProps, nextProps);
});